import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const DEFAULTS = {
  title: 'Kitxens — Restaurant Operating Intelligence | AI Visibility & Revenue',
  description:
    'The system of record for restaurant discoverability and revenue intelligence in the AI era. Free Index AI™ scan, direct orders with zero commission, AI receptionist, guest data and operating automation — Kitxens.',
  url: 'https://www.kitxens.com',
  image: 'https://customer-assets.emergentagent.com/job_kitxens-redesign/artifacts/2ewlt32z_image.png',
};

export default function SEO({ title, description, path = '/', image, schema }) {
  const hasBrand = !!title && /kitxens/i.test(title);
  const finalTitle = title ? (hasBrand ? title : `${title} — Kitxens`) : DEFAULTS.title;
  const finalDesc = description || DEFAULTS.description;
  const finalImage = (image || DEFAULTS.image).startsWith('/')
    ? `https://www.kitxens.com${image}`
    : (image || DEFAULTS.image);
  const url = `${DEFAULTS.url}${path}`;
  // Single canonical tag: update the server-rendered #kx-canonical (no Helmet duplicate).
  useEffect(() => {
    try { document.getElementById('kx-canonical')?.setAttribute('href', url); } catch { /* noop */ }
  }, [url]);
  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDesc} />
      <meta property="og:image" content={finalImage} />
      <meta property="og:site_name" content="Kitxens" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDesc} />
      <meta name="twitter:image" content={finalImage} />

      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}
